import { makeStyles } from '@material-ui/core';

import { colors } from 'src/themes/colors';

export const useStyles = makeStyles({
  title: {
    fontFamily: 'Avenir-Black',
    fontSize: 28,
    color: colors.black4,
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '30px 30px 0',
  },
  dialogContent: {
    display: 'inline-block',
    padding: '0 30px',
    minWidth: 700,
  },
  descriptionText: {
    marginTop: 10,
  },
  deleteConfirmContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 150,
    marginBottom: 108,
  },
  providerCard: {
    display: 'flex',
    flexDirection: 'column',
    border: `2px solid ${colors.blue7}`,
    borderRadius: 4,
    boxShadow: '0 2px 10px 0 rgba(208, 209, 210, 0.24)',
    margin: '15px 0',
  },
  providerHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '22px 20px 22px 20px',
  },
  providerLogo: {
    width: 30,
    objectFit: 'contain',
  },
  profileName: {
    fontSize: 14,
    fontWeight: 900,
    marginLeft: 25,
  },
  actionsButtonGroup: {
    marginLeft: 'auto',
  },
  actionsButtonStyle: {
    color: colors.black2,
    fontSize: 12,
  },
  actionsButtonResyncIcon: {
    color: colors.turquoise1,
    fontSize: '1rem',
  },
  actionsButtonDeleteIcon: {
    maxHeight: 16,
    marginBottom: 4,
  },
  bannerDeleteIcon: {
    maxHeight: 16,
    marginRight: 6,
  },
  calendarList: {
    display: 'flex',
    flexDirection: 'column',
  },
  calendar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderTop: `2px solid ${colors.blue7}`,
    paddingLeft: 20,
  },
  calendarIconWrapper: {
    backgroundColor: colors.blue7,
    borderRadius: 5,
    padding: '6px 6px 0 6px',
  },
  calendarIcon: {
    fontSize: 20,
    color: colors.blue6,
  },
  calendarName: {
    marginLeft: 25,
    marginRight: 15,
    fontWeight: 900,
    fontSize: 14,
  },
  readonlyPill: {
    fontSize: 12,
    margin: 20,
    padding: '5px 8px 5px 8px',
    backgroundColor: colors.gray11,
    color: colors.white1,
    borderRadius: 5,
  },
  calendarActions: {
    marginLeft: 'auto',
  },
  addProviderCard: {
    cursor: 'pointer',
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
  addIcon: {
    fontSize: 36,
    color: colors.blue3,
    marginRight: 15,
  },
  addText: {
    display: 'flex',
    flexDirection: 'column',
  },
  addTitle: {
    fontSize: 14,
    fontWeight: 900,
  },
  addSubtitle: {
    fontSize: 12,
    color: colors.gray5,
  },
  notificationWrapper: {
    display: 'flex',
    margin: '40px 40px 0px 40px',
    padding: '4px 10px',
    borderRadius: 7.2,
    alignItems: 'center',
  },
  errorTextWrapper: {
    backgroundColor: '#ffccd8',
  },
  successTextWrapper: {
    backgroundColor: '#caf0d5',
  },
  notificationText: {
    fontWeight: 500,
    fontSize: 13,
    marginTop: 3,
  },
  successText: {
    color: '#066641',
  },
  errorText: {
    color: colors.red2,
  },
  checkCircle: {
    fontSize: 18,
    color: '#066641',
    marginRight: 6,
  },
  syncingCircle: {
    fontSize: 18,
    color: '#066641',
    marginRight: 6,
  },
  errorCircle: {
    fontSize: 18,
    color: colors.red2,
    marginRight: 6,
  },
  iconDisplay: {
    fontSize: 22,
  },
  iconDisplayContainer: {
    height: 60,
  },
  iconDisplayBg: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: 'rgba(231, 237, 255, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconDisplayBgRed: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: 'rgba(255, 204, 216, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  redIcon: {
    color: colors.red2,
  },
  redBg: {
    backgroundColor: colors.red2,
    '&:hover': {
      backgroundColor: colors.red6,
    },
  },
  deleteConfirmTitle: {
    textAlign: 'center',
    fontSize: 20,
  },
  deleteConfirmText: {
    textAlign: 'center',
    paddingLeft: '6rem',
    paddingRight: '6rem',
  },
  deleteConfirmButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '1em',
  },
  padRight: {
    marginRight: 8,
  },
});
